<div class="grid-container">
  @for (child of children; track child) {
  <div class="child-item clickable">
    <div class="child-icon">
      @if (child.wstype==='folder') {
      <img
        class="child-img"
        src="assets/rubix-documents/folder_black_24dp.svg"
        alt="folder"
        (click)="toFolder(child)"
      />
      } @if (child.wstype!=='folder') {
      <img
        class="child-img"
        src="assets/rubix-documents/description_black_24dp.svg"
        alt="folder"
        (click)="onCheckboxClick(child)"
      />
      }
      <input
        class="child-checkbox"
        type="checkbox"
        [ngModel]="isChildSelected(child)"
        (click)="onCheckboxClick(child)"
      />
    </div>
    @if (child.wstype==='folder') {
    <div [title]="getTitle(child)" class="child-name" (click)="toFolder(child)">
      {{ child.name }}
    </div>
    } @if (child.wstype!=='folder') {
    <div
      [title]="getTitle(child)"
      class="child-name"
      (click)="onCheckboxClick(child)"
    >
      {{ child.name }}{{ child.extension ? "." + child.extension : "" }}
    </div>
    }
  </div>
  }
</div>
